<p-toast key="pesquisa"   position="center" ></p-toast>

<div *ngIf="votado" style="text-align: center;" class="titulo">
        <span>Obrigado por Compartilhar conosco sua opinião.</span> <br>
        <span>Colhemos dados constantemente para melhor atender nossos segurados.</span> <br>
        <img src="assets/sol.png" alt="">
</div>

<div *ngIf="!votado" style="text-align: center;">
  <span class="titulo"> Compartilhe conosco suas opiniões </span> 
  <hr>
  <span class="pergunta">O que você acha do nosso site?</span> <br>
  <div style="text-align: center;">
          <div *ngIf="corpo.site==0 || corpo.site==1"  pTooltip="Acho Péssimo" tooltipPosition="top" style="display: inline-block;" (click)="votar(1,'site')">
                  <img src="assets/pessimo.png" ><br>
                  <span class="sub"> Péssimo </span> 
          </div>
          <div *ngIf="corpo.site==0 || corpo.site==2"  pTooltip="Acho Ruim" tooltipPosition="top" style="display: inline-block; margin-left: 10px;" (click)="votar(2,'site')">
                  <img src="assets/ruim.png" ><br>
                  <span class="sub"> Ruim </span> 
          </div>
          <div *ngIf="corpo.site==0 || corpo.site==3" pTooltip="Acho Regular" tooltipPosition="top" style="display: inline-block; margin-left: 10px;" (click)="votar(3,'site')">
                  <img src="assets/regular.png" ><br>
                  <span class="sub"> Regular </span> 
          </div>
          <div *ngIf="corpo.site==0 || corpo.site==4" pTooltip="Acho Bom" tooltipPosition="top" style="display: inline-block; margin-left: 10px;" (click)="votar(4,'site')">
                  <img src="assets/bom.png" ><br>
                  <span class="sub"> Bom </span> 
          </div>
          <div *ngIf="corpo.site==0 || corpo.site==5" pTooltip="Acho Ótimo" tooltipPosition="top" style="display: inline-block; margin-left: 10px;" (click)="votar(5,'site')">
                  <img src="assets/otimo.png" ><br>
                  <span class="sub"> Ótimo </span> 
          </div>
  </div>

<br><br>
  <span class="pergunta" >E sobre a qualidade de atendimento do Instituto?</span> <br>
  <div style="text-align: center;">
          <div *ngIf="corpo.atendimento==0 || corpo.atendimento==1" pTooltip="Acho Péssimo" tooltipPosition="top" style="display: inline-block;" (click)="votar(1,'atendimento')">
                  <img src="assets/pessimo.png" ><br>
                  <span class="sub"> Péssimo </span> 
          </div>
          <div *ngIf="corpo.atendimento==0 || corpo.atendimento==2" pTooltip="Acho Ruim" tooltipPosition="top" style="display: inline-block; margin-left: 10px;" (click)="votar(2,'atendimento')">
                  <img src="assets/ruim.png" ><br>
                  <span class="sub"> Ruim </span> 
          </div>
          <div *ngIf="corpo.atendimento==0 || corpo.atendimento==3" pTooltip="Acho Regular" tooltipPosition="top" style="display: inline-block; margin-left: 10px;" (click)="votar(3,'atendimento')">
                  <img src="assets/regular.png" ><br>
                  <span class="sub"> Regular </span> 
          </div>
          <div *ngIf="corpo.atendimento==0 || corpo.atendimento==4" pTooltip="Acho Bom" tooltipPosition="top" style="display: inline-block; margin-left: 10px;" (click)="votar(4,'atendimento')">
                  <img src="assets/bom.png" ><br>
                  <span class="sub"> Bom </span> 
          </div>
          <div *ngIf="corpo.atendimento==0 || corpo.atendimento==5" pTooltip="Acho Ótimo" tooltipPosition="top" style="display: inline-block; margin-left: 10px;" (click)="votar(5,'atendimento')">
                  <img src="assets/otimo.png" ><br>
                  <span class="sub"> Ótimo </span> 
          </div>
  </div>

  <br><br>
  <span class="pergunta" >E sobre as instalações físicas do Diviprev?</span> <br>
  <div style="text-align: center;">
          <div *ngIf="corpo.instalacoes==0 || corpo.instalacoes==1" pTooltip="Acho Péssimo" tooltipPosition="top" style="display: inline-block;" (click)="votar(1,'instalacoes')">
                  <img src="assets/pessimo.png" ><br>
                  <span class="sub"> Péssimo </span> 
          </div>
          <div *ngIf="corpo.instalacoes==0 || corpo.instalacoes==2" pTooltip="Acho Ruim" tooltipPosition="top" style="display: inline-block; margin-left: 10px;" (click)="votar(2,'instalacoes')">
                  <img src="assets/ruim.png" ><br>
                  <span class="sub"> Ruim </span> 
          </div>
          <div *ngIf="corpo.instalacoes==0 || corpo.instalacoes==3" pTooltip="Acho Regular" tooltipPosition="top" style="display: inline-block; margin-left: 10px;" (click)="votar(3,'instalacoes')">
                  <img src="assets/regular.png" ><br>
                  <span class="sub"> Regular </span> 
          </div>
          <div *ngIf="corpo.instalacoes==0 || corpo.instalacoes==4" pTooltip="Acho Bom" tooltipPosition="top" style="display: inline-block; margin-left: 10px;" (click)="votar(4,'instalacoes')">
                  <img src="assets/bom.png" ><br>
                  <span class="sub"> Bom </span> 
          </div>
          <div *ngIf="corpo.instalacoes==0 || corpo.instalacoes==5" pTooltip="Acho Ótimo" tooltipPosition="top" style="display: inline-block; margin-left: 10px;" (click)="votar(5,'instalacoes')">
                  <img src="assets/otimo.png" ><br>
                  <span class="sub"> Ótimo </span> 
          </div>
  </div>

  

  <div style="text-align: center;"><br>
        <button pButton type="button" label="Enviar Pesquisa" class="ui-button-rounded ui-button-success" (click)="enviarPesquisa()"></button>
  </div>


</div>